{
  "V": "N",
  "constraints": [
    {
      "axis": "G1",
      "op": "==",
      "value": 0
    },
    {
      "axis": "G2",
      "op": "==",
      "value": 0
    },
    {
      "axis": "G3",
      "op": "==",
      "value": 0
    },
    {
      "axis": "G4",
      "op": "==",
      "value": 0
    }
  ],
  "notes": "Regime 1 = origin only.",
  "region_id": "REGION_R1_ORIGIN"
}
